import Accordion from './Accordion'
import AccordionItem from './AccordionItem'

Accordion.Item = AccordionItem

export default Accordion
